import React from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { useToggle } from '@hooks'

const gradientStyles = {
  backgroundImage:
    'linear-gradient(to bottom, rgba(245, 245, 245,0), rgba(245, 245, 245,1))',
  background:
    'linear-gradient(to bottom, rgba(245, 245, 245,0), rgba(245, 245, 245,1))',
}
export const ReadMoreAccordion = ({ accordionContent, className }) => {
  const { isToggled, toggle } = useToggle(false)
  return (
    <div className={className}>
      <AnimatePresence>
        <motion.div
          className="relative z-10 mt-4 overflow-hidden prose md:prose-lg lg:prose-xl"
          initial="collapsed"
          animate={`${isToggled ? 'expanded' : 'collapsed'}`}
          transition={{ ease: 'easeInOut' }}
          variants={{
            collapsed: { height: 200 },
            expanded: { height: 'auto' },
          }}
          exit={{ height: 200 }}
        >
          <div dangerouslySetInnerHTML={{ __html: accordionContent }}></div>
        </motion.div>
      </AnimatePresence>
      {!isToggled && (
        <div
          role="presentation"
          className="relative z-20 block h-16 -mt-16"
          style={gradientStyles}
        ></div>
      )}
      <button
        className="inline-block mt-4 font-sans text-xl font-bold tracking-wide text-gray-400 no-underline uppercase transition duration-200 border-b-4 border-gray-400 sm:border-b-6 hover:border-brand-yellow sm:text-2xl"
        onClick={toggle}
      >
        {isToggled ? `Read Less` : `Read More`}
      </button>
    </div>
  )
}
